import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {AdminService} from '../../app/shared/services/admin.service';
import { TopbarComponent } from '../shared/components/topbar/topbar.component';
import { SidebarComponent } from '../shared/components/sidebar/sidebar.component';
import { BottombarComponent } from '../shared/components/bottombar/bottombar.component';

@Component({
    selector: 'app-api-keys',
    templateUrl: './api-keys.component.html',
    styleUrls: ['./api-keys.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TopbarComponent, SidebarComponent, BottombarComponent]
})
export class ApiKeysComponent implements OnInit {
secretKey
publicKey

  constructor(private adminService: AdminService, private toastr: ToastrService) { }

  ngOnInit() {
    this.getDetails();
  }



getDetails() {
    this.adminService.getDetails().subscribe(
      data => {
        this.secretKey = data[0].agent.secret_key;
        this.publicKey = data[0].agent.public_key;
       
    });
  }

copyPublic() {
  navigator.clipboard.writeText(this.publicKey).then(() => {
    
     this.toastr.success('Public key copied!');
  }).catch(err => {
     this.toastr.error('Failed to copy public key', 'Error');
  });
}

copySecret() {
  navigator.clipboard.writeText(this.secretKey).then(() => {
    
     this.toastr.success('Secret key copied!');
  }).catch(err => {
     this.toastr.error('Failed to copy secret key', 'Error');
  });
}

}
